// Session 1 clinical questionnaires — Spanish

export const LIKERT_4 = [
  { value: 0, label: "Nada" },
  { value: 1, label: "Varios días" },
  { value: 2, label: "Más de la mitad de los días" },
  { value: 3, label: "Casi todos los días" },
];

export const LIKERT_DIFFICULTY = [
  { value: 0, label: "Para nada difícil" },
  { value: 1, label: "Un poco difícil" },
  { value: 2, label: "Muy difícil" },
  { value: 3, label: "Extremadamente difícil" },
];

export const PHQ9 = {
  kind: "phq9",
  title: "PHQ-9 · Cuestionario sobre la Salud del Paciente",
  intro:
    "Durante las últimas 2 semanas, ¿qué tan seguido le han afectado cualquiera de los siguientes problemas?",
  scale: LIKERT_4,
  items: [
    "Poco interés o placer en hacer las cosas",
    "Se ha sentido decaído(a), deprimido(a), o sin esperanzas",
    "Dificultad para dormir o permanecer dormido(a), o ha dormido demasiado",
    "Se ha sentido cansado(a) o con poca energía",
    "Con poco apetito o ha comido en exceso",
    "Se ha sentido mal con usted mismo(a) — o que es un fracaso, o que ha quedado mal con usted mismo(a) o con su familia",
    "Ha tenido dificultad para concentrarse en cosas tales como leer el periódico o ver televisión",
    "¿Se ha estado moviendo o hablando tan lento que otras personas podrían notarlo?, o por el contrario ha estado tan inquieto(a) o agitado(a), que se ha estado moviendo mucho más de lo normal",
    "Ha pensado que estaría mejor muerto(a) o se le ha ocurrido lastimarse de alguna manera",
  ],
};

export const GAD7 = {
  kind: "gad7",
  title: "GAD-7 · Trastorno de Ansiedad Generalizada",
  intro: "Señale con qué frecuencia ha sufrido los siguientes problemas en los últimos 15 días:",
  scale: LIKERT_4,
  items: [
    "Se ha sentido nervioso, ansioso o muy alterado",
    "No ha podido dejar de preocuparse",
    "Se ha preocupado excesivamente por diferentes cosas",
    "Ha tenido dificultad para relajarse",
    "Se ha sentido tan intranquilo que no podía estarse quieto",
    "Se ha irritado o enfadado con facilidad",
    "Ha sentido miedo, como si fuera a suceder algo terrible",
  ],
};

const GHQ_SCALE_A = [
  { value: 0, label: "Mejor que lo habitual" },
  { value: 1, label: "Igual que lo habitual" },
  { value: 2, label: "Peor que lo habitual" },
  { value: 3, label: "Mucho peor que lo habitual" },
];
const GHQ_SCALE_B = [
  { value: 0, label: "No, en absoluto" },
  { value: 1, label: "No más de lo habitual" },
  { value: 2, label: "Bastante más que lo habitual" },
  { value: 3, label: "Mucho más que lo habitual" },
];
const GHQ_SCALE_C = [
  { value: 0, label: "Más que lo habitual" },
  { value: 1, label: "Igual que lo habitual" },
  { value: 2, label: "Peor que lo habitual" },
  { value: 3, label: "Mucho peor que lo habitual" },
];

export const GHQ28 = {
  kind: "ghq28",
  title: "GHQ-28 · Cuestionario de Salud General de Goldberg",
  intro:
    "Conteste señalando la respuesta que más se acerca a lo que usted siente. Nos interesan los problemas recientes y actuales, no del pasado.",
  sections: [
    {
      title: "A. Síntomas somáticos",
      scale: GHQ_SCALE_A,
      items: [
        "¿Se ha sentido bien de salud y en plena forma?",
        "¿Ha tenido la sensación de que necesitaba un reconstituyente?",
        "¿Se ha sentido agotado y sin fuerzas para nada?",
        "¿Ha tenido la sensación de que estaba enfermo?",
        "¿Ha padecido dolores de cabeza?",
        "¿Ha tenido sensación de opresión en la cabeza, o de que la cabeza le iba a estallar?",
        "¿Ha tenido oleadas de calor o escalofríos?",
      ],
    },
    {
      title: "B. Ansiedad e insomnio",
      scale: GHQ_SCALE_B,
      items: [
        "¿Sus preocupaciones le han hecho perder mucho sueño?",
        "¿Ha tenido dificultades para seguir durmiendo de un tirón toda la noche?",
        "¿Se ha notado constantemente agobiado y en tensión?",
        "¿Se ha sentido con los nervios a flor de piel y malhumorado?",
        "¿Se ha asustado o tenido pánico sin motivo?",
        "¿Ha tenido la sensación de que todo se le viene encima?",
        "¿Se ha notado nervioso y 'a punto de explotar' constantemente?",
      ],
    },
    {
      title: "C. Disfunción social",
      scale: GHQ_SCALE_C,
      items: [
        "¿Se las ha arreglado para mantenerse ocupado y activo?",
        "¿Le cuesta más tiempo hacer las cosas?",
        "¿Ha tenido la impresión, en conjunto, de que está haciendo las cosas bien?",
        "¿Se ha sentido satisfecho con su manera de hacer las cosas?",
        "¿Ha tenido la sensación de que está jugando un papel útil en la vida?",
        "¿Se ha sentido capaz de tomar decisiones?",
        "¿Ha sido capaz de disfrutar de sus actividades normales de cada día?",
      ],
    },
    {
      title: "D. Depresión",
      scale: GHQ_SCALE_B,
      items: [
        "¿Ha pensado que usted es una persona que no vale para nada?",
        "¿Ha venido viviendo la vida totalmente sin esperanza?",
        "¿Ha tenido el sentimiento de que la vida no merece la pena vivirse?",
        "¿Ha pensado en la posibilidad de 'quitarse de en medio'?",
        "¿Ha notado que a veces no puede hacer nada porque tiene los nervios desquiciados?",
        "¿Ha notado que desea estar muerto y lejos de todo?",
        "¿Ha notado que la idea de quitarse la vida le viene repentinamente a la cabeza?",
      ],
    },
  ],
};

// BHS — 20 T/F. Value 1 = respuesta de desesperanza (según la clave del test).
// Simplificamos: para cada frase, el usuario elige V/F; guardamos 1 si la respuesta indica desesperanza.
export const BHS = {
  kind: "bhs",
  title: "BHS · Escala de Desesperanza de Beck",
  intro: "Marca Verdadero (V) o Falso (F) según cómo te has sentido en los últimos días.",
  // hopeless_when: valor que marca desesperanza
  items: [
    { text: "Espero el futuro con esperanza y entusiasmo.", hopeless_when: "F" },
    { text: "Puedo darme por vencido, ya que no puedo hacer mejor las cosas por mí mismo.", hopeless_when: "V" },
    { text: "Cuando las cosas van mal, me alivia saber que no pueden permanecer así.", hopeless_when: "F" },
    { text: "No puedo imaginar cómo será mi vida dentro de 10 años.", hopeless_when: "V" },
    { text: "Tengo bastante tiempo libre para llevar a cabo las cosas que quisiera.", hopeless_when: "F" },
    { text: "En el futuro, espero conseguir lo que me pueda interesar.", hopeless_when: "F" },
    { text: "Mi futuro me parece oscuro.", hopeless_when: "V" },
    { text: "Espero más cosas buenas de la vida que lo que la gente suele conseguir por término medio.", hopeless_when: "F" },
    { text: "No logro hacer que las cosas cambien, y no existen razones para creer que pueda en el futuro.", hopeless_when: "V" },
    { text: "Mis pasadas experiencias me han preparado bien para mi futuro.", hopeless_when: "F" },
    { text: "Todo lo que puedo ver por delante de mí es más desagradable que agradable.", hopeless_when: "V" },
    { text: "No espero conseguir lo que realmente deseo.", hopeless_when: "V" },
    { text: "Cuando miro hacia el futuro, espero que seré más feliz de lo que soy ahora.", hopeless_when: "F" },
    { text: "Las cosas no marchan como yo quisiera.", hopeless_when: "V" },
    { text: "Tengo una gran confianza en el futuro.", hopeless_when: "F" },
    { text: "Nunca consigo lo que deseo, por lo que es absurdo desear cualquier cosa.", hopeless_when: "V" },
    { text: "Es muy improbable que pueda lograr una satisfacción real en el futuro.", hopeless_when: "V" },
    { text: "El futuro me parece vago e incierto.", hopeless_when: "V" },
    { text: "Espero más buenos momentos que malos.", hopeless_when: "F" },
    { text: "No merece la pena que intente conseguir algo que desee, porque probablemente no lo lograré.", hopeless_when: "V" },
  ],
};

export const SWLS = {
  kind: "swls",
  title: "SWLS · Escala de Satisfacción con la Vida",
  intro: "Indica tu grado de acuerdo con cada frase (1 = totalmente en desacuerdo, 7 = totalmente de acuerdo).",
  scale: [1, 2, 3, 4, 5, 6, 7],
  items: [
    "En la mayoría de aspectos, mi vida se acerca a mi ideal.",
    "Las condiciones de mi vida son excelentes.",
    "Estoy satisfecho/a con mi vida.",
    "Hasta ahora, he conseguido las cosas importantes que quiero en la vida.",
    "Si pudiera vivir mi vida otra vez, no cambiaría casi nada.",
  ],
};

export const PERMA = {
  kind: "perma",
  title: "Escala PERMA · Bienestar",
  intro: "Marca de 0 a 10 según corresponda a tu experiencia habitual.",
  scale: Array.from({ length: 11 }, (_, i) => i),
  items: [
    "En general, ¿con qué frecuencia te sientes con emociones positivas?",
    "¿Con qué frecuencia te sientes absorbido/a en lo que haces?",
    "¿Cómo valoras tus relaciones personales?",
    "¿Qué sentido/propósito percibes en tu vida?",
    "¿Con qué frecuencia sientes que logras lo que te propones?",
  ],
};

export const ALL_QUESTIONNAIRES = [PHQ9, GAD7, GHQ28, BHS, SWLS, PERMA];
